module.exports = __webpack_public_path__ + "img/zhaoxiannashi.1abd0e71.png";